import { ThemeColors } from "../theme/colorNames";
export const opacity = (hex, opacity) => {
    return (hex +
        Math.floor(opacity * 255)
            .toString(16)
            .padStart(2, "0"));
};
export const generateCSSVars = (theme, rgbTheme, themeType) => {
    return `:root{
    ${ThemeColors.color_primary_p_40}: ${theme.colors.primary[40]};
    ${ThemeColors.color_primary_p_50}: ${theme.colors.primary[50]};
    ${ThemeColors.color_primary_p_60}: ${theme.colors.primary[60]};
    ${ThemeColors.color_neutrals_n_100}: ${theme.colors.dark[100]};
    ${ThemeColors.color_neutrals_n_200}: ${theme.colors.dark[200]};
    ${ThemeColors.color_neutrals_n_300}: ${theme.colors.dark[300]};
    ${ThemeColors.color_neutrals_n_400}: ${theme.colors.dark[400]};
    ${ThemeColors.color_neutrals_n_500}: ${theme.colors.dark[500]};
    ${ThemeColors.color_neutrals_n_600}: ${theme.colors.dark[600]};
    ${ThemeColors.color_neutrals_on_primary}: ${theme.colors.light.on_primary};
    ${ThemeColors.color_neutrals_n_00}: ${theme.colors.light[0]};
    ${ThemeColors.color_neutrals_n_10}: ${theme.colors.light[10]};
    ${ThemeColors.color_neutrals_n_20}: ${theme.colors.light[20]};
    ${ThemeColors.color_neutrals_n_30}: ${theme.colors.light[30]};
    ${ThemeColors.color_neutrals_n_40}: ${theme.colors.light[40]};
    ${ThemeColors.color_neutrals_n_50}: ${theme.colors.light[50]};
    ${ThemeColors.color_neutrals_gold_bg}: ${theme.colors.light.gold_bg};
    ${ThemeColors.color_neutrals_surface}: ${theme.colors.light.surface};
    ${ThemeColors.color_bubble_out_primary} : ${theme.colors.bubble.out_primary};
    ${ThemeColors.color_bubble_in_primary}: ${theme.colors.bubble.in_primary};
    ${ThemeColors.color_bubble_out_secondary} : ${theme.colors.bubble.out_secondary};
    ${ThemeColors.color_bubble_in_secondary} : ${theme.colors.bubble.in_secondary};
    ${ThemeColors.color_bubble_low_text}: ${theme.colors.bubble.low_text};
    ${ThemeColors.color_bubble_receipt}: ${theme.colors.bubble.receipt};
    ${ThemeColors.color_error}: ${theme.colors.error};
    ${ThemeColors.color_success}: ${theme.colors.success};
    ${ThemeColors.color_link}: ${theme.colors.link};
    ${ThemeColors.color_alert}: ${theme.colors.alert};
    ${ThemeColors.skeleton_color}:${theme.colors.skeleton};
    ${ThemeColors.magazine_gradient_start}: ${theme.colors.magazine.gradient_start};
    ${ThemeColors.magazine_gradient_end}: ${theme.colors.magazine.gradient_end};
    ${ThemeColors.color_alternative_a_01}: ${theme.colors.alternative[1]};
    ${ThemeColors.color_alternative_a_02}: ${theme.colors.alternative[2]};
    ${ThemeColors.color_alternative_a_03}: ${theme.colors.alternative[3]};
    ${ThemeColors.color_alternative_a_04}: ${theme.colors.alternative[4]};
    ${ThemeColors.color_alternative_a_05}: ${theme.colors.alternative[5]};
    ${ThemeColors.color_alternative_a_06}: ${theme.colors.alternative[6]};
    ${ThemeColors.color_alternative_a_07}: ${theme.colors.alternative[7]};
    ${ThemeColors.color_alternative_a_08}: ${theme.colors.alternative[8]};
    ${ThemeColors.color_alternative_a_09}: ${theme.colors.alternative[9]};
    ${ThemeColors.color_alternative_a_10}: ${theme.colors.alternative[10]};
    
    --color-primary-p-40-rgb: ${rgbTheme.primary[40]};
    --color-primary-p-50-rgb: ${rgbTheme.primary[50]};
    --color-primary-p-60-rgb: ${rgbTheme.primary[60]};
    --color-neutrals-n-100-rgb: ${rgbTheme.dark[100]};
    --color-neutrals-n-200-rgb: ${rgbTheme.dark[200]};
    --color-neutrals-n-300-rgb: ${rgbTheme.dark[300]};
    --color-neutrals-n-400-rgb: ${rgbTheme.dark[400]};
    --color-neutrals-n-500-rgb: ${rgbTheme.dark[500]};
    --color-neutrals-n-600-rgb: ${rgbTheme.dark[600]};
    --color-neutrals-on-primary-rgb:${rgbTheme.light.on_primary};
    --color-neutrals-gold-bg-rgb:${rgbTheme.light.gold_bg};
    --color-neutrals-n-00-rgb: ${rgbTheme.light[0]};
    --color-neutrals-n-10-rgb: ${rgbTheme.light[10]};
    --color-neutrals-n-20-rgb: ${rgbTheme.light[20]};
    --color-neutrals-n-30-rgb: ${rgbTheme.light[30]};
    --color-neutrals-n-40-rgb: ${rgbTheme.light[40]};
    --color-neutrals-n-50-rgb: ${rgbTheme.light[50]};

    --color-alternative-a-01-rgb: ${rgbTheme.alternative.a01};
    --color-alternative-a-02-rgb: ${rgbTheme.alternative.a02};
    --color-alternative-a-03-rgb: ${rgbTheme.alternative.a03};
    --color-alternative-a-04-rgb: ${rgbTheme.alternative.a04};
    --color-alternative-a-05-rgb: ${rgbTheme.alternative.a05};
    --color-alternative-a-06-rgb: ${rgbTheme.alternative.a06};
    --color-alternative-a-07-rgb: ${rgbTheme.alternative.a07};
    --color-alternative-a-08-rgb: ${rgbTheme.alternative.a08};
    --color-alternative-a-09-rgb: ${rgbTheme.alternative.a09};
    --color-alternative-a-10-rgb: ${rgbTheme.alternative.a10};

    ${ThemeColors.color_alternative_opacity_a_01}: rgba(${rgbTheme.alternative.a01}, ${rgbTheme.alternative.opacity});
    ${ThemeColors.color_alternative_opacity_a_02}: rgba(${rgbTheme.alternative.a02}, ${rgbTheme.alternative.opacity});
    ${ThemeColors.color_alternative_opacity_a_03}: rgba(${rgbTheme.alternative.a03}, ${rgbTheme.alternative.opacity});
    ${ThemeColors.color_alternative_opacity_a_04}: rgba(${rgbTheme.alternative.a04}, ${rgbTheme.alternative.opacity});
    ${ThemeColors.color_alternative_opacity_a_05}: rgba(${rgbTheme.alternative.a05}, ${rgbTheme.alternative.opacity});
    ${ThemeColors.color_alternative_opacity_a_06}: rgba(${rgbTheme.alternative.a06}, ${rgbTheme.alternative.opacity});
    ${ThemeColors.color_alternative_opacity_a_07}: rgba(${rgbTheme.alternative.a07}, ${rgbTheme.alternative.opacity});
    ${ThemeColors.color_alternative_opacity_a_08}: rgba(${rgbTheme.alternative.a08}, ${rgbTheme.alternative.opacity});
    ${ThemeColors.color_alternative_opacity_a_09}: rgba(${rgbTheme.alternative.a09}, ${rgbTheme.alternative.opacity});
    ${ThemeColors.color_alternative_opacity_a_10}: rgba(${rgbTheme.alternative.a10}, ${rgbTheme.alternative.opacity});

    --color-neutrals-surface-rgb:${rgbTheme.light.surface};
    --color-bubble-out-primary-rgb:${rgbTheme.bubble.out_primary};
    --color-bubble-in-primary-rgb:${rgbTheme.bubble.in_primary};
    --color-bubble-out-secondary-rgb:${rgbTheme.bubble.out_secondary};
    --color-bubble-in-secondary-rgb:${rgbTheme.bubble.in_secondary};
    --color-bubble-low-text-rgb:${rgbTheme.bubble.low_text};
    --color-bubble-receipt-rgb: ${rgbTheme.bubble.receipt};
    --color-neutrals-snack-bar-rgb: ${rgbTheme.snack};
    --color-bubble-mask-rgb: ${rgbTheme.mask};
    --color-bubble-out-third-rgb:${rgbTheme.bubble.out_third};
    --color-bubble-in-third-rgb:${rgbTheme.bubble.in_third};
    --color-neutrals-service-message-rgb:${rgbTheme.bubble.service_message};
    --color-ripple-rgb: ${rgbTheme.ripple};
    --color-primary-ripple-rgb: ${rgbTheme.primary_ripple};

    ${ThemeColors.color_gradient_magazine}: ${theme.colors.gradient.magzine};
    ${ThemeColors.color_gradient_skeleton}: ${theme.colors.gradient.skeleton};
    ${ThemeColors.color_gradient_story_arbaein}: ${theme.colors.gradient.story_arbaein};
    ${ThemeColors.color_gradient_story_world}: ${theme.colors.gradient.story_world};
    ${ThemeColors.color_gradient_story_yalda}: ${theme.colors.gradient.story_yalda};
    ${ThemeColors.color_gradient_story}: ${theme.colors.gradient.story};

    ${generateShadowVariables(rgbTheme, themeType)}
    }`;
};
export const generateShadowVariables = (rgbTheme, themeType) => {
    const isLight = themeType == "light";
    return `
  --bubble-shadow: ${isLight ? `0px 0px 2px 0px rgba(var(${rgbTheme.dark[500]}), 0.16)` : "none"};
  --option-modal-shadow: ${isLight ? `0px 1px 4px 0px rgba(var(${rgbTheme.dark[500]}), 0.15)` : "none"} ;
  --option-modal-shadow-2: ${isLight ? `0px 0px 4px 0px rgba(var(${rgbTheme.dark[500]}), 0.28)` : "none"};
  --box-shadow: ${isLight ? `0px 0px 8px 0px rgba(var(${rgbTheme.dark[500]}), 0.08)` : "none"};
  --modal-shadow: ${isLight ? `0px 5px 15px 0px rgba(var(${rgbTheme.dark[500]}), 0.15)` : "none"} ;
  --input-bar-navigation: ${isLight ? `0px -1px 4px 0px rgba(var(${rgbTheme.dark[500]}), 0.08)` : "none"};`;
};
export const getColorByName = (colorName, rgb) => {
    const isKeyColor = Object.keys(ThemeColors).find((color) => color === colorName);
    const isValueColor = Object.values(ThemeColors).find((color) => color === colorName);
    const rgbPostfix = rgb ? "-rgb" : "";
    if (isKeyColor) {
        return `var(${ThemeColors[colorName] + rgbPostfix})`;
    }
    else if (isValueColor) {
        return `var(${colorName + rgbPostfix})`;
    }
    else {
        return colorName;
    }
};
//# sourceMappingURL=color.js.map